import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { EventService } from '../services/event-service/event.service';
import { StateroomComponent } from './components/stateroom/stateroom.component';
import { TravelPartyComponent } from './travel-party.component';
import { TravelPartyService } from './services/travel-party.service';
import { URLService } from '../url/url.service';
import { WarningMessagingModule } from './../warning-messaging/warning-messaging.module';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        WarningMessagingModule
    ],
    declarations: [
        StateroomComponent,
        TravelPartyComponent
    ],
    providers: [
        EventService,
        TravelPartyService,
        URLService
    ],
    exports: [
        TravelPartyComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class TravelPartyModule { }
